import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const YesNoRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const handleChange = (optionValue: string) => {
    onChange(optionValue);
  };

  return (
    <div className="space-y-3">
      <label
        className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-all ${
          value === 'yes'
            ? 'border-green-500 bg-green-50'
            : error
            ? 'border-red-200 hover:border-red-300'
            : 'border-gray-200 hover:border-gray-300'
        }`}
      >
        <input
          type="radio"
          name={question.id}
          value="yes"
          checked={value === 'yes'}
          onChange={() => handleChange('yes')}
          className="mt-1 h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300"
        />
        <div className="ml-3 flex-1">
          <span className="block text-gray-900 font-medium">Yes</span>
        </div>
      </label>

      <label
        className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-all ${
          value === 'no'
            ? 'border-red-500 bg-red-50'
            : error
            ? 'border-red-200 hover:border-red-300'
            : 'border-gray-200 hover:border-gray-300'
        }`}
      >
        <input
          type="radio"
          name={question.id}
          value="no"
          checked={value === 'no'}
          onChange={() => handleChange('no')}
          className="mt-1 h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300"
        />
        <div className="ml-3 flex-1">
          <span className="block text-gray-900 font-medium">No</span>
        </div>
      </label>
    </div>
  );
};

export default YesNoRenderer;
